import { Box, Card, Heading, Paragraph, TextButton } from '@zillow/constellation-10';
import { PaymentStep1SVGComponent, PaymentStep2SVGComponent } from './LandingPageSvgs';

interface HowPaymentsWorkProps {
  scrollToCostToPay?: () => void;
}

const HowPaymentsWork = (props: HowPaymentsWorkProps) => {
  const renderSection = ({ IconComponent, header, body }) => (
    <Card elevated={false} css={{ padding: '20px' }}>
      <div>
        <IconComponent />
      </div>
      <Paragraph css={{ marginTop: 'default', marginBottom: 'default' }} textStyle="body-bold">
        {header}
      </Paragraph>
      <Paragraph>{body}</Paragraph>
    </Card>
  );

  return (
    <Box css={{ textAlign: 'center', padding: '60px 16px' }}>
      <Box
        css={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
          gap: 'default',
          textAlign: 'center',
        }}
      >
        <Heading textStyle="heading-sm" level={2}>
          How do online payments work?
        </Heading>
        <Paragraph css={{ marginBottom: 'default' }}>
          Once your landlord invites you, verify what they told us, then...
        </Paragraph>
      </Box>

      <Box css={{ display: 'grid', gridTemplateColumns: { base: '1fr', md: 'repeat(2, 1fr)' }, gap: 'loose' }}>
        {renderSection({
          IconComponent: PaymentStep1SVGComponent,
          header: 'Choose how you would like to pay',
          body: (
            <>
              <Paragraph>You can pay with a debit or credit card or straight from your bank account.</Paragraph>
              <TextButton css={{ marginTop: 'default' }} onClick={props.scrollToCostToPay}>
                Tell me more
              </TextButton>
            </>
          ),
        })}
        {renderSection({
          IconComponent: PaymentStep2SVGComponent,
          header: 'Schedule your first payment',
          body: 'Make a single payment or set up recurring auto-payments.',
        })}
      </Box>
    </Box>
  );
};

export default HowPaymentsWork;
